import script from "./StepPass.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPass.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import AmountField from "@/components/neue/wizard/AmountField.vue";
import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
import InputArea from "@/components/neue/InputArea.vue";
import InputField from "@/components/neue/InputField.vue";
import PillRadioGroup from "@/components/neue/wizard/PillRadioGroup.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import ToggleRow from "@/components/neue/wizard/ToggleRow.vue";
import WizardButton from "@/components/neue/wizard/WizardButton.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { AmountField, HighlightedText, InputArea, InputField, PillRadioGroup, SelectInput, ToggleRow, WizardButton, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { AmountField, HighlightedText, InputArea, InputField, PillRadioGroup, SelectInput, ToggleRow, WizardButton, WizardSection }, script.__o.components);}